<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="modal" mainClass="fixed z-[61]">
    <div class="py-2"></div>

    <form
      @submit.prevent="
        $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION, {
          bookmakerId:
            $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerId,
          bookmaker: $stores.bookmaker?.state?.bookmakerIdSetting?.bookmaker
        })
      "
    >
      <div class="mb-8">
        <ImgComponent
          :src="
            $stores.bookmaker?.state?.bookmakerIdSetting
              ?.bookmakerIdPageScreenshot
          "
          class="rounded-4xl shadow-lg border border-neutral-500 w-full h-60 object-cover object-top"
          alt=""
        />
      </div>
      <div class="col-span-12 flex flex-col" required>
        <label class="mb-1 text-xl">
          Entrez Votre Id
        </label>
        <input
          v-model="$stores.bookmaker.state.bookmakerIdSetting.bookmakerId"
          type="text"
          class="p-4 border rounded-xl border-neutral-200 focus:border-primary-400 w-full"
          placeholder="Ex: 61020304"
        />
      </div>
      <div class="flex gap-4 mt-8 justify-end">
        <button
          type="button"
          class="buttonComponent bg-transparent! border-primary text-primary! border"
          @click="() => $refs.modal.hide()"
        >
          Retour
        </button>

        <button type="submit" class="buttonComponent bg-primary!">
          Utiliser
        </button>
      </div>
    </form>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BuyGiftCardForm'
});
</script>
